import React,{useState,useEffect} from "react";
import styles from "./genai.module.scss";
export const CustomAccordion = ({ title, children,contentPadding ,icon}) => {
  const [open, setOpen] = useState(false);
useEffect(() => {
    if (title === "elements" || title === "reasoning") {
      setOpen(true);
    }
  }, [title]);
   const isSpecialHeader = title === "reasoning" && open;
  return (
    <div className={`${styles.accordionWrapper} ${open ? styles.open : ""}`}>
  <div   className={`${styles.accordionHeader} ${
        isSpecialHeader ? styles.reasoningHeader : ""
      }`} onClick={() => setOpen(!open)}>
    <span className={styles.accordionBox}>

    <span className={styles.accordionTitle}>{icon ? icon :null}{title}</span>
    {title === "elements" && open  && (<span className={styles.accordionElem}>Select elements</span>)}
    </span>
    <div className={`${styles.iconBox} ${open ? styles.minus : styles.plus}`}></div>
  </div>

  <div className={styles.accordionContent} style={contentPadding&&open ? { padding: contentPadding } : {}}>{children}</div>
</div>

  );
};
